import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadTheme,  setDarkMode, toggleTheme } from './theme.actions';
import { tap, map, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectDarkMode } from './theme.selectors';
import { StorageService } from '../../app/auth/storage.service';

@Injectable()
export class ThemeEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private _storageService = inject(StorageService);

  toggle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(toggleTheme),
      withLatestFrom(this.store.select(selectDarkMode)),
     map(([, dark]) => setDarkMode({ darkMode: !dark }))

    )
  );

  
  applyTheme$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setDarkMode),
        tap(({ darkMode }) => {
          
          const html = document.documentElement;
          html.classList.toggle('dark', darkMode);

      
          this._storageService.setItem(
            'theme',
            darkMode ? 'dark' : 'light'
          );
        })
      ),
    { dispatch: false }
  );
  loadTheme$ = createEffect(() =>
  this.actions$.pipe(
    ofType(loadTheme),
    map(() => {
      const saved = this._storageService.getItem('theme');
      return setDarkMode({ darkMode: saved === 'dark' });
    })
  )
);




}
